import { normalizeEmotion } from "../../utils/emotion";
import { clamp } from "./chunk-0.jsx";
import { pickOledKind } from "./chunk-1.jsx";
import { OledIrisEye } from "./chunk-14.jsx";
import { OledEye } from "./chunk-16.jsx";
export function OledOfficialEyes({
  emotion,
  profile,
  blinkPulse
}) {
  const style = pickOledKind(emotion);
  const kind = style.kind;
  const gap = profile.gap ?? style.gap ?? 14;
  const eyeBoxW = typeof profile.eyeBoxW === 'number' ? profile.eyeBoxW : 0.28;
  const eyeBoxH = typeof profile.eyeBoxH === 'number' ? profile.eyeBoxH : 0.58;
  return <div className="w-full h-full flex items-center justify-center">
      <div className="relative w-[78%] h-[56%] flex items-center justify-center" style={{
      gap: `${gap}%`
    }}>
        <OledEye kind={kind} side="left" tilt={style.tilt} blinkPulse={blinkPulse} seedKey={`oled:${emotion}`} boxW={eyeBoxW} boxH={eyeBoxH} gazeName={profile.gaze} />
        <OledEye kind={kind} side="right" tilt={style.tilt} blinkPulse={blinkPulse} seedKey={`oled:${emotion}`} boxW={eyeBoxW} boxH={eyeBoxH} gazeName={profile.gaze} />
        {style.blush && <>
            <div className="absolute left-[18%] bottom-[-10%] w-[14%] h-[10%] rounded-full bg-pink-500/25 blur-[1px]" />
            <div className="absolute right-[18%] bottom-[-10%] w-[14%] h-[10%] rounded-full bg-pink-500/25 blur-[1px]" />
          </>}
      </div>
    </div>;
}
export function OledIrisEyes({
  emotion,
  profile,
  blinkPulse
}) {
  const e = normalizeEmotion(emotion);
  const gap = profile.gap ?? 14;
  const eyeRadius = clamp(profile.eyeRadius ?? 0.5, 0.1, 0.9);
  const pupil = clamp(profile.pupil ?? 0.35, 0, 0.9);
  const isSleepy = e === 'sleepy';
  const isAngry = e === 'angry';
  const isSurprised = e === 'surprised';
  const isLoving = e === 'loving';
  const isSad = e === 'sad' || e === 'crying';
  const openness = (() => {
    if (isSleepy) return 0.16;
    if (isAngry) return 0.45;
    if (isSad) return 0.5;
    if (isSurprised) return 0.95;
    return 0.75;
  })();
  const pupilScale = (() => {
    if (pupil <= 0) return 0;
    if (isSurprised) return pupil * 0.65;
    if (isLoving) return pupil * 1.25;
    return pupil;
  })();
  const tilt = isAngry ? 10 : 0;
  const irisColor = profile.iris || (isLoving ? '#fb7185' : '#111827');
  const pupilShape = profile.pupilShape || 'round';
  const gazeName = profile.gaze || 'oledGaze';
  return <div className="w-full h-full flex items-center justify-center">
      <div className="relative w-[78%] h-[56%] flex items-center justify-center" style={{
      gap: `${gap}%`
    }}>
        <OledIrisEye side="left" eyeRadius={eyeRadius} pupilScale={pupilScale} openness={openness} outline={Boolean(profile.outline)} outlineWidth={profile.outlineWidth} tilt={tilt} blinkPulse={blinkPulse} irisColor={irisColor} irisRing={Boolean(profile.irisRing)} pupilShape={pupilShape} pupilPulse={Boolean(profile.pupilPulse)} gazeName={gazeName} seedKey={`oled-iris:${emotion}`} />
        <OledIrisEye side="right" eyeRadius={eyeRadius} pupilScale={pupilScale} openness={openness} outline={Boolean(profile.outline)} outlineWidth={profile.outlineWidth} tilt={tilt} blinkPulse={blinkPulse} irisColor={irisColor} irisRing={Boolean(profile.irisRing)} pupilShape={pupilShape} pupilPulse={Boolean(profile.pupilPulse)} gazeName={gazeName} seedKey={`oled-iris:${emotion}`} />
        {isLoving && <>
            <div className="absolute left-[18%] bottom-[-10%] w-[14%] h-[10%] rounded-full bg-pink-500/25 blur-[1px]" />
            <div className="absolute right-[18%] bottom-[-10%] w-[14%] h-[10%] rounded-full bg-pink-500/25 blur-[1px]" />
          </>}
      </div>
    </div>;
}
